<template>
  <div>
    <v-layout wrap>
      <v-flex pt-4 text-left>
        <span style="font-family:poppinsextrabold;font-size:30px;color:#1C1C1C">My Account</span>
      </v-flex>
    </v-layout>
    <v-layout pb-12 wrap>
      <v-flex xs2 text-left>
        <v-img src="./../../assets/account.svg" height="70px" contain></v-img>
      </v-flex>
      <v-flex xs10>
        <v-layout wrap>
          <v-flex xs12 text-left>
            <span
              style="font-family:poppinsbold;font-size:18px;color:#1C1C1C"
              v-if="userData.fullname"
            >{{userData.fullname}}</span>
          </v-flex>
          <v-flex xs12 text-left>
            <span
              style="font-family:poppinsregular;font-size:14px;color:#1C1C1C"
              v-if="userData.email"
            >{{userData.email}}</span>
          </v-flex>
          <v-flex xs12 text-left>
            <span
              style="font-family:poppinsregular;font-size:14px;color:#1C1C1C"
              v-if="userData.phone"
            >+91 {{userData.phone}}</span>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout py-4 wrap>
      <v-flex xs1>
        <v-img src="./../../assets/icons/credit-card.svg" height="20px" contain></v-img>
      </v-flex>
      <v-flex text-left>
        <span style="font-family:poppinsbold;font-size:16px;color:#000">Payment Method</span>
      </v-flex>
    </v-layout>
    <v-layout py-4 wrap>
      <v-flex xs1>
        <v-img src="./../../assets/icons/shopping-bag.svg" height="20px" contain></v-img>
      </v-flex>
      <v-flex text-left>
        <span style="font-family:poppinsbold;font-size:16px;color:#000">Order History</span>
      </v-flex>
    </v-layout>
    <v-layout py-4 wrap>
      <v-flex xs1>
        <v-img src="./../../assets/icons/shopping-bag.svg" height="20px" contain></v-img>
      </v-flex>
      <v-flex text-left>
        <span style="font-family:poppinsbold;font-size:16px;color:#000">Delivery Address</span>
      </v-flex>
    </v-layout>
    <v-layout wrap>
      <v-flex py-4 px-2>
        <v-divider color="#f6f6f6"></v-divider>
      </v-flex>
    </v-layout>
    <v-layout wrap>
      <v-flex py-2 xs12 text-left>
        <span style="font-family:poppinsbold;font-size:16px;color:#000">My List</span>
      </v-flex>
      <v-flex py-2 xs12 text-left>
        <span style="font-family:poppinsbold;font-size:16px;color:#000">Legal Information</span>
      </v-flex>
      <v-flex py-2 xs12 text-left>
        <span style="font-family:poppinsbold;font-size:16px;color:#000">FAQ's</span>
      </v-flex>
      <v-flex py-2 xs12 text-left>
        <span style="font-family:poppinsbold;font-size:16px;color:#000">Contact us</span>
      </v-flex>
      <v-flex py-2 xs12 text-left>
        <span style="font-family:poppinsbold;font-size:16px;color:#000">Logout</span>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: ["userData"],
  data() {
    return {};
  },
  beforeMount() {},
};
</script>